namespace $ {
	export class $habr_notes extends $mol_page {
		
		/**
		 * ```tree
		 * plugins / <= Theme
		 * ```
		 */
		plugins() {
			return [
				this.Theme()
			] as readonly any[]
		}
		
		/**
		 * ```tree
		 * yard $hyoo_sync_client
		 * ```
		 */
		@ $mol_mem
		yard() {
			const obj = new this.$.$hyoo_sync_client()
			
			return obj
		}
		
		/**
		 * ```tree
		 * tools /
		 * 	<= Online
		 * 	<= Lighter
		 * ```
		 */
		tools() {
			return [
				this.Online(),
				this.Lighter()
			] as readonly any[]
		}
		
		/**
		 * ```tree
		 * body / <= Input
		 * ```
		 */
		body() {
			return [
				this.Input()
			] as readonly any[]
		}
		
		/**
		 * ```tree
		 * Theme $mol_theme_auto
		 * ```
		 */
		@ $mol_mem
		Theme() {
			const obj = new this.$.$mol_theme_auto()
			
			return obj
		}
		
		/**
		 * ```tree
		 * Online $hyoo_sync_online yard <= yard
		 * ```
		 */
		@ $mol_mem
		Online() {
			const obj = new this.$.$hyoo_sync_online()
			
			obj.yard = () => this.yard()
			
			return obj
		}
		
		/**
		 * ```tree
		 * Lighter $mol_lights_toggle
		 * ```
		 */
		@ $mol_mem
		Lighter() {
			const obj = new this.$.$mol_lights_toggle()
			
			return obj
		}
		
		/**
		 * ```tree
		 * text?val \
		 * ```
		 */
		@ $mol_mem
		text(val?: any) {
			if ( val !== undefined ) return val as never
			return ""
		}
		
		/**
		 * ```tree
		 * i_have_can_mod false
		 * ```
		 */
		i_have_can_mod() {
			return false
		}
		
		/**
		 * ```tree
		 * Input $mol_textarea
		 * 	value?val <=> text?val
		 * 	enabled <= i_have_can_mod
		 * ```
		 */
		@ $mol_mem
		Input() {
			const obj = new this.$.$mol_textarea()
			
			obj.value = (val?: any) => this.text(val)
			obj.enabled = () => this.i_have_can_mod()
			
			return obj
		}
	}
	
}

